import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import FieldStyles from '../Field/Field.styles';
const Container = styled.div `
  @media ${from(Device.TabletSmall)} {
    &[data-split-row='true'] {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      gap: 40px;

      ${FieldStyles.Field} {
        &:nth-child(1) {
          grid-column: 1;
        }
        &:nth-child(2) {
          grid-column: 2;
        }
      }

      select {
        padding-right: 26px;
      }
    }

    &[data-inline-row='true'] {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
    }
  }
`;
export default {
    Container,
};
